export const getErrorTextStyle = () => ({
  color: '#A80000',
  fontStyle: 'normal',
  fontWeight: 'normal',
  fontSize: 12,
  lineHeight: '16px',
});
